import VerticalDivider from "./VerticalDivider";

export default VerticalDivider;
